import {FC} from 'react';
import {Link} from 'react-router-dom';
import cn from 'classnames';

import {Stack, SxProps, Theme, Typography} from '@mui/material';

import {IMenuItem, IMenuItemDynamicLink} from '../../shared/types/menu.types';

import styles from './NavCard.module.scss';

interface INavCard {
  item: IMenuItem | IMenuItemDynamicLink;
  useMediaForce?: boolean;
  sxTitle?: SxProps<Theme>;
}

export const NavCard: FC<INavCard> = ({item, sxTitle = {}, useMediaForce = false}) => {
  return (
    <div className={cn(styles.navCard, {[styles.useMedia]: useMediaForce})}>
      <Link draggable={false} state={'data' in item ? item.data : undefined} to={item.link}>
        <Stack direction="column" sx={{justifyContent: 'center'}}>
          {item.Icon && <item.Icon />}
        </Stack>
        {item.Icon ? (
          <div className={styles.withIcon}>
            <Typography
              component="div"
              sx={{
                fontWeight: 600,
                ...sxTitle,
              }}
            >
              {item.title}
            </Typography>
          </div>
        ) : (
          <Stack direction="row" sx={{justifyContent: 'center', alignItems: 'center', width: '100%'}}>
            <Typography
              component="div"
              sx={{
                fontWeight: 600,
                textAlign: 'center',
                ...sxTitle,
              }}
            >
              {item.title}
            </Typography>
          </Stack>
        )}
      </Link>
    </div>
  );
};
